import { css } from '@emotion/react';

export const illustrationsBase = css`
  --side-field-size: calc((100vw - 100% - var(--scrollbar-width)) / 2);

  position: absolute;
  z-index: -1;
  height: auto;
`;
